@import '../styles/_vars.css';

.bgLight {
  background-color: var(--color-bg-light);
}

.contentContainer {
  display: flex;
  flex-flow: column;
}

.contentContainer + .ctaContainer {
  margin-top: 30px;
}

.ctaContainer {
  align-items: center;
  display: flex;
  flex-flow: column;
  gap: 1.5rem;
  justify-content: center;
  align-items: center;
}

.ctaContainer a {
  width: max-content;
}

.left {
  padding: 0;
  text-align: center;
}

.right {
  text-align: center;
}

.right img {
  width: 100%;
  max-width: 500px;
  display: inline-block;
  height: auto;
}

.textImage {
  display: flex;
  flex-direction: column;
  gap: 35px;
  justify-content: space-between;
  padding: 35px 35px 45px;
}

.textImage h1 {
  margin-bottom: 0.8em;
}

.textImage h1 b {
  color: var(--color-text-emphasize);
}

.textImage p {
  font-size: 1.25em;
}

@media screen and (min-width: 770px) {
  .ctaContainer {
    align-items: flex-start;
    flex-flow: row wrap;
    align-items: center;
    justify-content: flex-start;
  }

  .ctaContainer a {
    flex: 0 0 auto;
    width: max-content;
    padding-left: 1.25em;
    padding-right: 1.25em;
  }

  .left {
    text-align: left;
    width: 50%;
    padding-left: 2.25rem;
    padding-right: 2.25rem;
  }

  .right {
    width: 50%;
  }

  .right img {
    display: block;
    max-height: none;
    max-width: 620px;
  }

  .textImage {
    align-items: center;
    flex-direction: row;
    padding: 0;
    gap: 0;
  }

  .textImage h1 {
    font-size: 2em;
  }
}

@media screen and (min-width: 1280px) {
  .textImage h1 {
    font-size: 2.5em;
  }
}

@media screen and (min-width: 1480px) {
  .left {
    padding-left: 50px;
    padding-right: 115px;
    width: auto;
  }

  .right {
    width: auto;
  }

  .right img {
    width: auto;
  }

  .textImage h1 {
    font-size: 3em;
  }
}
